import { useDocumentsConsent } from "./use-documents-consent";

export const useListDocumentsConsent = () => {
  const { ListDocumentsQuery } = useDocumentsConsent();
  const { data, isLoading, error } = ListDocumentsQuery();
  return { data, isLoading, error };
};
